import Cookies from 'js-cookie';

export default function menu() {
    const alert = document.getElementById('alert');
    if (!alert) {
        return;
    }
    const alert_close = document.getElementById('alert_close');
    if (!alert_close) {
        return;
    }
    const alertCookie = Cookies.get('alert_message');
    if (alertCookie !== alert['dataset'].message) {
        alert.classList.add('block');
    }

    alert_close.addEventListener('click', function (ev) {
        alert.classList.remove('block');
        alert.classList.add('none');
        Cookies.set('alert_message', alert['dataset'].message || '');
    });
}
